/** Headers for admin API calls (Apache/LiteSpeed may strip Authorization on uploads). */
export function adminHeaders(token, { json = false } = {}) {
  const headers = {
    Authorization: `Bearer ${token}`,
    'X-Admin-Token': token,
  };
  if (json) headers['Content-Type'] = 'application/json';
  return headers;
}

export function adminAuthErrorMessage(res, data) {
  if (res.status === 401) {
    return data?.error || 'Session expired. Please log out and log in again.';
  }
  return data?.error || `Request failed (${res.status})`;
}
